module.exports = __webpack_public_path__ + "img/universe.9474ad1e.png";